module.exports = __webpack_public_path__ + "static/media/port.9cd06eea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/port.jpg
// module id = 191
// module chunks = 0